// src/components/Education.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaUniversity, FaCheckCircle } from 'react-icons/fa';
import './Education.css';

const Education = ({ t }) => {
  return (
    <section className="education" id="education">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title neon-text">{t.education.title}</h2>

          <div className="education-content">
            {/* Master's Degree */}
            <motion.div
              className="education-card neon-border current"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02, boxShadow: 'var(--glow-blue)' }}
            >
              <div className="edu-icon-container">
                <FaGraduationCap className="edu-icon" />
                <span className="status-badge current-badge">
                  {t.education.status}
                </span>
              </div>

              <div className="edu-details">
                <h3 className="edu-degree neon-text-green">
                  {t.education.degree}
                </h3>
                <p className="edu-field">{t.education.field}</p>
                
                <div className="edu-institution">
                  <FaUniversity className="institution-icon" />
                  <span>{t.education.institution}</span>
                </div>
              </div>

              <div className="edu-decoration">
                <div className="decoration-circle"></div>
                <div className="decoration-circle"></div>
                <div className="decoration-circle"></div>
              </div>
            </motion.div>

            {/* Bachelor's Degree */}
            <motion.div
              className="education-card neon-border-green completed"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02, boxShadow: 'var(--glow-green)' }}
            >
              <div className="edu-icon-container">
                <FaCheckCircle className="edu-icon completed-icon" />
                <span className="status-badge completed-badge">
                  {t.education.bachelorStatus}
                </span>
              </div>

              <div className="edu-details">
                <h3 className="edu-degree neon-text">
                  {t.education.bachelor}
                </h3>
                <p className="edu-field">{t.education.field}</p>
                
                <div className="edu-institution">
                  <FaUniversity className="institution-icon" />
                  <span>{t.education.institution}</span>
                </div>
              </div>

              <div className="edu-decoration">
                <div className="decoration-circle"></div>
                <div className="decoration-circle"></div>
                <div className="decoration-circle"></div>
              </div>
            </motion.div>
          </div>

          {/* Timeline Connection */}
          <div className="timeline-connector">
            <motion.div 
              className="timeline-line"
              initial={{ height: 0 }}
              whileInView={{ height: '100%' }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: true }}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Education;
